import React from 'react';
import defaultRenderEmpty from './renderEmpty';
const defaultPrefixCls = 'b-design';
const defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls)
        return customizePrefixCls;
    return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
};
const ConfigContext = React.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: defaultGetPrefixCls,
    renderEmpty: defaultRenderEmpty
});
export const ConfigConsumer = ConfigContext.Consumer;
export { withConfigConsumer } from 'antd/es/config-provider/context';
export { ConfigContext };
